import { Card, Grid, Table, TableBody, TableContainer } from "@mui/material";
import Container from "@mui/material/Container";
import moment from "moment";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import AppLoadingAndErrorWrapper from "src/components/common/AppLoadingAndErrorWrapper";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs/custom-breadcrumbs";
import Header from "src/components/Header";
import FormProvider from "src/components/hook-form/form-provider";
import Scrollbar from "src/components/scrollbar";
import { useSettingsContext } from "src/components/settings";
import StatisticCard from "src/components/StatisticCard";
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from "src/components/table";
import { paths } from "src/routes/paths";
import GiftsTableRow from "src/sections/gifts/GiftsTableRow";
import GiftsTableToolbar from "src/sections/gifts/GiftsTableToolbar";
import UserBadgesTableRow from "./UserBadgesTableRow";

const TABLE_HEAD = [
  { id: "1", label: "Badge" },
  { id: "2", label: "Badge name" },
  { id: "3", label: "Program name" },
  { id: "4", label: "Winning date" },
  { id: "5", label: "Actions" },
];

export default function UserBadges () {
  const settings = useSettingsContext();
  const table = useTable({ defaultRowsPerPage: 10 });
  const { useGetListApi, useDeleteApi } = useApiServices();
  const { userId } = useParams();
  const methods = useForm({
    defaultValues: {},
  });
  const [search, setSearch] = useState<any>({});

  const { data, isLoading, error, refetch, isRefetching } = useGetListApi<
    ResDataType["userBadges"]
  >({
    url: API_URLS.USER_BADGES(userId!),
    parameters: {
      page: table.page,
      pageSize: table.rowsPerPage,
    },
  });

  const { mutate, isLoading: isDeleteLoading } = useDeleteApi({
    url: API_URLS.USER_BADGES(userId!),
    urlAfterSuccess: window.location.href,
    onSuccess: () => refetch(),
  });

  return (
    <>
      <Helmet>
        <title>Badges</title>
      </Helmet>
      <Container maxWidth={settings.themeStretch ? false : "xl"}>
        {/* {isInGift && (
          <CustomBreadcrumbs
            links={[
              {
                name: "Home",
                href: paths.dashboard.root,
              },
              {
                name: "Gifts",
                href: paths.dashboard.gifts.received,
              },
            ]}
          />
        )} */}
        <AppLoadingAndErrorWrapper
          isLoading={isLoading || isDeleteLoading || isRefetching}
          errorMessage={error}
        >
          {/* {isInGift && (
            <Header header={`Today, ${moment().format("YYYY-MM-DD")}`} />
          )} */}
          <Grid container spacing={4} my={1}>
            <Grid item xs={12}>
              <FormProvider methods={methods}>
                <Card>
                  <TableContainer>
                    <Scrollbar>
                      <Table>
                        <TableHeadCustom headLabel={TABLE_HEAD} />
                        <TableBody>
                          {isLoading ? (
                            [...Array(table.rowsPerPage)].map((i, index) => (
                              <TableSkeleton key={index} sx={{ height: 80 }} />
                            ))
                          ) : (
                            <>
                              {data!?.items?.map((row: any) => (
                                <UserBadgesTableRow
                                  key={row.id}
                                  row={row}
                                />
                              ))}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </Scrollbar>
                  </TableContainer>
                  {data && (
                    <TablePaginationCustom
                      count={data?.totalItems}
                      page={data.currentPage ? +data.currentPage - 1 : 1}
                      rowsPerPage={table.rowsPerPage}
                      onPageChange={table?.onChangePage}
                      onRowsPerPageChange={table?.onChangeRowsPerPage}
                    />
                  )}
                </Card>
              </FormProvider>
            </Grid>
          </Grid>
        </AppLoadingAndErrorWrapper>
      </Container>
    </>
  );
}
